import styled from 'styled-components';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import media from '../../styles/config/mediaQueries';

const StyledSearch = styled.div`
  position: relative;
  ${media.mobile`
    height: 43px;
    margin: 36px 0 14px;
  `}
  ${media.desktop`
    height: 36px;
    margin-left: 20px;
    width: 325px;
  `}

  svg {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);

    path {
      //fill: ${theme.color.gray};
      // TODO: uncomment this
      fill: ${rgba(theme.color.white, 0.6)};
    }
    ${media.mobile`
      width: 17px;
      right: 19px;
    `}
    ${media.desktop`
      width: 13px;
      right: 22px;
    `}
  }
`;

const StyledInput = styled.input`
  width: 100%;
  height: 100%;
  border-radius: 100px;
  padding: 0 45px 0 20px;
  background-color: ${props =>
    props.info ? rgba(theme.color.white, 0.15) : rgba(theme.color.white, 0.05)};

  //color: ${theme.color.gray};
  /* TODO: uncomment this line, and delete line under */
  color: ${props => (props.info ? rgba(theme.color.white, 0.6) : theme.color.gray)};

  caret-color: ${theme.color.gray};
  line-height: 24px;
  &::placeholder {
    // TODO: Only leave theme.color.gray
    color: ${props => (props.info ? rgba(theme.color.white, 0.6) : theme.color.gray)};
    font-family: Poppins, sans-serif;
  }
`;

export { StyledSearch, StyledInput };
